import React from 'react'
import PropTypes from 'prop-types'

export const LoadBlock = ({ isActive }) => (isActive && <div className='PhotoSlider-loadBlock'/>)

LoadBlock.propTypes = {
  isActive: PropTypes.bool
}
